import { Box, Container, Grid, Typography, Link } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

import lendleImage from "../../assets/lendle.svg";
import takoImage from "../../assets/tako.svg";
import gmxbtImage from "../../assets/gmxbt.svg";

const ProjectCard = ({ image, title, subtitle, description, link }) => (
  <Grid
    container
    spacing={0}
    style={{
      border: "1px solid",
      borderColor: "rgba(13, 71, 255, 0.1)",
    }}
  >
    {/* <Box
      sx={{
        p: 4,
        height: "100%",
        borderRadius: 2,
        bgcolor: "#fff",
      }}
    > */}
    <Grid item xs={12} md={6} style={{ padding: 18 }}>
      <Box
        component="img"
        src={image}
        alt={title}
        sx={{
          width: "100%",
          height: "auto",
          borderRadius: 2,
          mb: 3,
        }}
      />
    </Grid>
    <Grid item xs={12} md={6} style={{ padding: 18 }}>
      <Typography
        variant="h3"
        sx={{
          fontSize: "20px",
          fontWeight: 400,
          color: "#0D47FF",
          mb: 1,
        }}
      >
        {title}
      </Typography>

      <Typography
        sx={{
          fontSize: "14px",
          color: "rgba(0, 0, 0, 0.6)",
          letterSpacing: "0.1em",
          textTransform: "uppercase",
          mb: 2,
        }}
      >
        {subtitle}
      </Typography>

      <Typography
        sx={{
          fontSize: "14px",
          lineHeight: 1.6,
          mb: 3,
        }}
      >
        {description}
      </Typography>

      <Link
        href={link}
        target="_blank"
        rel="noopener"
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          color: "#0D47FF",
          textDecoration: "none",
          fontSize: "14px",
          fontWeight: 500,
          "&:hover": {
            textDecoration: "underline",
          },
        }}
      >
        Explore project
        <OpenInNewIcon sx={{ fontSize: 18 }} />
      </Link>
    </Grid>
    {/* </Box> */}
  </Grid>
);

const Projects = () => {
  const projectsData = [
    {
      image: lendleImage,
      title: "Lendle",
      subtitle: "LENDING & BORROWING ON MANTLE",
      description:
        "Lendle is a high-performance decentralized lending and borrowing protocol built on the Mantle network. It provides seamless access to capital markets with secure smart contracts, low transaction costs, and AI-driven risk management.",
      link: "https://lendle.io",
    },
    {
      image: takoImage,
      title: "TAKOTAKO",
      subtitle: "LENDING & BORROWING ON TAIKO",
      description:
        "TAKOTAKO is a decentralized liquidity market protocol deployed on Taiko. It enables permissionless lending and borrowing, powered by an automated risk management framework optimized for the Taiko ecosystem.",
      link: "https://takotako.io",
    },
    {
      image: gmxbtImage,
      title: "GMXBT",
      subtitle: "AI-POWERED INVESTMENT FUNDS",
      description:
        "GMXBT is an AI-driven investment platform that optimizes portfolio management for digital assets. Utilizing machine learning algorithms, GMXBT dynamically adjusts investment strategies for risk-adjusted returns in the DeFi market.",
      link: "https://gmxbt.io",
    },
  ];

  return (
    <Box sx={{ py: { xs: 4, md: 8 } }}>
      <Container maxWidth="lg">
        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: "32px", md: "48px" },
            fontWeight: 400,
            mb: { xs: 6, md: 8 },
          }}
        >
          Projects
        </Typography>

        <Grid container spacing={0}>
          {projectsData.map((project, index) => (
            <Grid item xs={12} md={6} key={index}>
              <ProjectCard {...project} />
            </Grid>
          ))}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Link
                href="/contact"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  color: "#000",
                  textDecoration: "none",
                  fontSize: "18px",
                  fontWeight: 500,
                  "&:hover": {
                    color: "#0D47FF",
                  },
                }}
              >
                Contact Us →
              </Link>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Projects;
